<template>
  <hys-dialog
    :title="step === 1 ? '取消订单' : '申请退款'"
    :visible.sync="dialogVisible"
    :width="step === 1 ? '580px' : '680px'"
    :append-to-body="true"
    :before-close="handleClose"
  >
    <div class="wrap">
      <p class="hint" v-if="step === 1">
        若线下未转账成功，解除订单请选取“取消订单”；若线下已转账成功，解除订单请选取“申请退款”。
      </p>
      <p class="title" v-else>请输入需退款的银行账号信息</p>
      <div v-if="step === 1" class="choose">
        <el-radio v-model="radio" :label="1">取消订单</el-radio>
        <el-radio v-model="radio" :label="2">申请退款</el-radio>
      </div>
      <el-form
        :model="bankInfo"
        :rules="rules"
        ref="bankInfo"
        label-width="200px"
        style="margin-bottom:45px"
        v-else
      >
        <el-form-item label="账户名称：" prop="BankName">
          <el-input
            v-model="bankInfo.BankName"
            style="width:360px"
            maxlength="50"
            placeholder="请输入账户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="银行卡号：" prop="BankNo">
          <el-input
            v-model="bankInfo.BankNo"
            style="width:360px"
            maxlength="30"
            placeholder="请输入银行卡号"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户行名称：" prop="AccountName">
          <el-input
            v-model="bankInfo.AccountName"
            style="width:360px"
            maxlength="50"
            placeholder="请输入开户行名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btns">
        <el-button
          type="primary"
          :style="{
            width: '140px',
            background: '#0F6EEA',
            opacity: radio != 1 && radio != 2 ? 0.5 : 1,
          }"
          :disabled="radio != 1 && radio != 2"
          @click="handleSure"
          v-if="step === 1"
          >确定</el-button
        >
        <template v-else>
          <el-button
            style="width:140px;margin-right:70px"
            :disabled="radio != 1 && radio != 2"
            @click="step = 1"
            >取消</el-button
          >
          <el-button
            type="primary"
            :style="{
              width: '140px',
              background: '#0F6EEA',
              opacity:
                bankInfo.BankName && bankInfo.BankNo && bankInfo.AccountName
                  ? 1
                  : 0.5,
            }"
            :disabled="
              !(bankInfo.BankName && bankInfo.BankNo && bankInfo.AccountName)
            "
            @click="submitBankInfo"
            >确定</el-button
          >
        </template>
      </div>
    </div>
  </hys-dialog>
</template>
<script>
import HysDialog from '@/components/HysDialog'
export default {
  name: 'CancelOrder',
  data() {
    return {
      dialogVisible: false,
      radio: '',
      step: 1,
      bankInfo: {
        AccountName: '',
        BankName: '',
        BankNo: '',
      },
      dataInfo: {},
      rules: {
        BankName: [
          { required: true, message: '请输入账户名称', trigger: 'blur' },
        ],
        BankNo: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' },
        ],
        AccountName: [
          { required: true, message: '请输入开户行名称', trigger: 'blur' },
        ],
      },
    }
  },
  components: {
    HysDialog,
  },
  methods: {
    handleShow(info) {
      this.dialogVisible = true
      this.dataInfo = info
    },
    handleClose() {
      this.dialogVisible = false
      this.step = 1
      this.radio = ''
      this.bankInfo = { AccountName: '', BankName: '', BankNo: '' }
    },
    handleSure() {
      if (this.radio === 2) {
        this.step = 2
        this.getBankInfo()
      } else {
        this.cancelOrder()
      }
    },
    cancelOrder() {
      this.$hys.openLoading()
      this.postAction('/api_order/Orders/CancelOrderV2', {
        OrderId: this.dataInfo.Id,
        OrderNo: this.dataInfo.OrderNo,
      }).then((res) => {
        this.$hys.clearLoading()
        if (!res.IsSuccess) {
          this.$toast({ position: 'bottom', message: res.Msg })
          return
        }
        this.$toast.success('取消成功')
        this.handleClose()
        this.$emit('againLoad')
      })
    },
    submitBankInfo() {
      this.$refs['bankInfo'].validate((valid) => {
        if (valid) {
          this.$hys.openLoading()
          this.putAction(
            '/api_aftersale/AfterSaleDocment/CustomerRefundOrder',
            Object.assign(
              { OrderId: this.dataInfo.Id, CustomerApplyRefundType: 2 },
              this.bankInfo
            )
          ).then((res) => {
            this.$hys.clearLoading()
            if (!res.Data) {
              this.$toast({ position: 'bottom', message: res.Msg })
              return
            }
            this.$toast.success('提交成功')
            this.handleClose()
            this.$emit('againLoad')
          })
        } else {
          return false
        }
      })
    },
    async getBankInfo() {
      this.$hys.openLoading()
      const res = await this.getAction(
        '/api_aftersale/AfterSaleDocment/GetLastOrderRefundApply',
        { orderId: this.dataInfo.Id }
      )
      this.$hys.clearLoading()
      if (res.IsSuccess && res.Data && res.Data.OrderNo) {
        this.bankInfo = {
          AccountName: res.Data.AccountName,
          BankName: res.Data.BankName,
          BankNo: res.Data.BankNo,
        }
      } else {
        if (res.Msg) {
          this.$toast({ position: 'bottom', message: res.Msg })
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
.wrap {
  text-align: left;
  .hint {
    color: #e47d2f;
    font-size: 12px;
    background: #fff7e9;
    line-height: 26px;
    padding: 0px 5px;
  }
  .title {
    text-align: center;
    font-size: 14px;
    color: #222222;
    margin-top: 17px;
    margin-bottom: 40px;
  }
  .choose {
    margin-bottom: 100px;
    margin-top: 30px;
  }
  .btns {
    text-align: center;
  }
}
</style>
